import PropTypes from 'prop-types'

const PageTitle = ({ pageTitle }) => {
  return (
    <div className="font-avenir-heavy flex justify-between pb-4">
      <div className="flex justify-start">
        <div className="type-header-1 max-tablet-p:type-header-2">{pageTitle}</div>
      </div>
    </div>
  )
}

PageTitle.propTypes = {
  pageTitle: PropTypes.string.isRequired,
}

export default PageTitle
